/* collection-swag.js
 * 8/26 rewrite. No setInterval anywhere.
 *
 * PASS 1 of the paint-then-swap cleanup. Removed cartRecs() — the "You may also like"
 * grid on the cart page. It did grid.innerHTML='' and rebuilt the block from
 * /recommendations/products.json, which is why the same four products appeared on every
 * load and then changed a beat later. The block is a normal Featured-collection section;
 * it is now pointed at the "cart-best-sellers" smart collection (vendor = 9FIVE Eyewear,
 * sorted best selling, so no accessories, apparel, Rx add-ons, gift cards or services)
 * and renders server-side with no swap.
 *
 * 8/28: logoSwap() was DELETED — the last paint-then-swap in this file.
 * config/settings_data.json settings.logo now points at 9five-logo-trademark.png, so the
 * correct logo is in the HTML the server sends, and the sizing/crop that the .swag-logo
 * class used to carry lives in collection-swag.css keyed off the logo link instead of a
 * JS-applied class. The old behaviour was worse than a flash: the swap ran once on
 * DOMContentLoaded and raced the header, so on loads where the header was not in the DOM
 * yet it silently did nothing and the small stock logo stayed. That is why the logo
 * looked different from one collection page to the next.
 *
 * 8/28: heroLogo() was DELETED. The homepage hero headline block (templates/index.json,
 * hero_main > h_headline) now carries the logo <img> directly, so it renders server-side
 * with no flash of the "9FIVE® Eyewear" text.
 *
 * Earlier the same day: the two polling loops (a 1500ms loop inside <collection-swag>
 * and a 2500ms global loop) were removed, along with _atc(), _hideSold(), _trySwap(),
 * tx(), galleryXL() and all the static <style> injection. Remaining functions are
 * genuine one-shot DOM edits and run on DOMContentLoaded plus shopify:section:load.
 *
 * Still outstanding (pass 2/3): featuredCards() below still hides the theme's product
 * title and injects its own title + price from a fetch, and assets/more-colors.js still
 * rewrites the PDP <h1> and rebuilds its colorway grid once per sibling fetch.
 */

class CollectionSwag extends HTMLElement {
  // Inert shell. The element is still present in several collection templates; keeping
  // it defined avoids an unknown-element no-op turning into a template edit across all
  // of them. It no longer schedules anything.
  connectedCallback() {}
}

if (!customElements.get('collection-swag')) customElements.define('collection-swag', CollectionSwag);

(function () {
  var MARBLE = "url('https://cdn.shopify.com/s/files/1/0145/6512/files/Screenshot_2026-06-25_at_8.18.02_AM.png?v=1782400726&width=600')";

  function footMarble() {
    // Text-conditional (finds the links column, not the newsletter column), so it stays
    // in JS rather than CSS. Runs once.
    try {
      var marble = 'https://cdn.shopify.com/s/files/1/0145/6512/files/Gemini_Generated_Image_3m9kyx3m9kyx3m9k.png?v=1782395141&width=1600';
      var secs = document.querySelectorAll('.shopify-section-group-footer-group');
      if (!secs.length) return;
      [].forEach.call(secs, function (s) {
        var sb = s.querySelector('.section-background.color-scheme-1');
        if (!sb || sb.getAttribute('data-fm') === '1') return;
        var t = (s.textContent || '').toLowerCase();
        var hasEmail = !!s.querySelector('input[type=email],input[name*=email]');
        if (!(/shop/.test(t) && /about/.test(t) && !hasEmail)) return;
        sb.style.setProperty('background-image', "linear-gradient(rgba(255,255,255,.55),rgba(255,255,255,.55)), url('" + marble + "')", 'important');
        sb.style.setProperty('background-size', 'cover', 'important');
        sb.style.setProperty('background-position', 'center', 'important');
        sb.style.setProperty('background-repeat', 'no-repeat', 'important');
        sb.setAttribute('data-fm', '1');
      });
    } catch (e) {}
  }

  function atcMarble() {
    // The PDP buy button carries an inline background-image the stylesheet can't beat,
    // so this stays imperative. Guarded by data-marble, runs once.
    try {
      var btns = document.querySelectorAll('.product-information .add-to-cart-button, .sticky-atc__btn, .sticky-add-to-cart__button');
      [].forEach.call(btns, function (b) {
        if (b.getAttribute('data-marble') === '1') return;
        b.setAttribute('data-marble', '1');
        b.style.setProperty('background-image', MARBLE, 'important');
        b.style.setProperty('background-size', 'cover', 'important');
        b.style.setProperty('background-position', 'center', 'important');
        b.style.setProperty('background-repeat', 'no-repeat', 'important');
        b.style.setProperty('background-color', '#030302', 'important');
        b.style.setProperty('color', '#fff', 'important');
        b.style.setProperty('text-shadow', '0 1px 3px rgba(0,0,0,.55)', 'important');
      });
    } catch (e) {}
  }

  function whySwag() {
    // Tags the section; the background itself is in collection-swag.css.
    try {
      var heads = [].slice.call(document.querySelectorAll('h1,h2,h3,h4'));
      var hdr = null;
      for (var i = 0; i < heads.length; i++) {
        if (/why\s*9five/i.test((heads[i].textContent || '').replace(/\s+/g, ' '))) { hdr = heads[i]; break; }
      }
      if (!hdr) return;
      var sec = hdr.closest('.shopify-section');
      if (!sec || sec.getAttribute('data-whyswag')) return;
      sec.setAttribute('data-whyswag', '1');
      sec.classList.add('why-swag');
    } catch (e) {}
  }

  function sizeFitMove() {
    try {
      var src = document.querySelector('.pdp-sizefit');
      if (!src || src.getAttribute('data-sfmoved')) return;
      var body = src.querySelector('.pdp-sizefit__body');
      if (!body) return;
      var accs = [].slice.call(document.querySelectorAll('accordion-custom, details.details'));
      var targets = accs.filter(function (a) {
        var s = a.querySelector('summary');
        return s && /size\s*(&|and)?\s*fit/i.test(s.textContent || '');
      });
      if (!targets.length) return;
      src.setAttribute('data-sfmoved', '1');
      targets.forEach(function (a) {
        var content = a.querySelector('.details-content') || a.querySelector('[class*=content]');
        if (!content || content.querySelector('.pdp-sizefit__moved')) return;
        var clone = body.cloneNode(true);
        clone.classList.add('pdp-sizefit__moved');
        content.insertBefore(clone, content.firstChild);
      });
    } catch (e) {}
  }

  function reviewStars() {
    try {
      var sec = document.querySelector('[id*=carousel_revie]');
      if (!sec) {
        var heads = [].slice.call(document.querySelectorAll('h1,h2,h3,h4'));
        for (var i = 0; i < heads.length; i++) {
          if (/saying|what they|9fivers/i.test((heads[i].textContent || '').replace(/\s+/g, ' '))) {
            sec = heads[i].closest('.shopify-section');
            break;
          }
        }
      }
      if (!sec) return;
      var cards = sec.querySelectorAll('[data-carousel-card],.card');
      [].forEach.call(cards, function (card) {
        if (card.getAttribute('data-stars')) return;
        if ((card.textContent || '').replace(/\s+/g, '').length < 15) return;
        card.setAttribute('data-stars', '1');
        var wrap = card.querySelector('[class*=spacing-style]') || card;
        if (wrap.querySelector('.swag-stars')) return;
        var stars = document.createElement('div');
        stars.className = 'swag-stars';
        stars.textContent = '★★★★★';
        wrap.insertBefore(stars, wrap.firstChild);
      });
    } catch (e) {}
  }

  function scrollReveal() {
    if (!('IntersectionObserver' in window)) return;
    if (!window.__luxIO) {
      window.__luxIO = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('lux-in'); window.__luxIO.unobserve(en.target); }
        });
      }, { threshold: .1, rootMargin: '0px 0px -6% 0px' });
    }
    [].slice.call(document.querySelectorAll('.shopify-section')).forEach(function (t) {
      if (t.getAttribute('data-lux')) return;
      t.setAttribute('data-lux', '1');
      if (t.getBoundingClientRect().top < window.innerHeight * 0.9) return;
      t.classList.add('lux-reveal');
      window.__luxIO.observe(t);
    });
    if (!window.__luxSafety) {
      window.__luxSafety = 1;
      setTimeout(function () {
        [].forEach.call(document.querySelectorAll('.lux-reveal'), function (e) { e.classList.add('lux-in'); });
      }, 4500);
    }
  }

  function featuredCards() {
    var heads = [].slice.call(document.querySelectorAll('h2,h3'));
    var hdr = null;
    for (var i = 0; i < heads.length; i++) {
      if (/signature styles|most wanted|best.?sell/i.test(heads[i].textContent || '')) { hdr = heads[i]; break; }
    }
    var sec = hdr ? hdr.closest('.shopify-section') : document.querySelector('[id*=product_list_bestsellers],[id*=bestseller]');
    if (!sec) return;
    sec.classList.add('lux-feat');
    [].forEach.call(sec.querySelectorAll('.product-card'), function (card) {
      if (card.getAttribute('data-luxc')) return;
      card.setAttribute('data-luxc', '1');
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      var hm = (link.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
      if (!hm) return;
      var handle = hm[1];
      var t = '';
      var vh = card.querySelector('.visually-hidden');
      if (vh) t = (vh.textContent || '').trim();
      if (!t) t = (link.getAttribute('aria-label') || '').trim();
      if (card.querySelector('.lux-meta')) return;
      var wrap = document.createElement('a');
      wrap.href = link.getAttribute('href');
      wrap.className = 'lux-meta';
      var tt = document.createElement('span');
      tt.className = 'lux-title';
      tt.textContent = t.replace(/\s+[–\-].*$/, '').slice(0, 40);
      var pp = document.createElement('span');
      pp.className = 'lux-price';
      wrap.appendChild(tt); wrap.appendChild(pp);
      card.appendChild(wrap);
      [].forEach.call(card.querySelectorAll('p,h2,h3,h4'), function (pe) {
        if (!pe.closest('.lux-meta') && (pe.textContent || '').trim() === t) {
          pe.style.setProperty('display', 'none', 'important');
        }
      });
      fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (pj) {
        var p = (pj.price != null) ? pj.price : ((pj.variants && pj.variants[0]) ? pj.variants[0].price : null);
        if (p != null) pp.textContent = '$' + (p / 100).toFixed(2);
        if (!tt.textContent && pj.title) tt.textContent = pj.title;
      }).catch(function () {});
    });
  }

  function heroKen() {
    try {
      var h = document.querySelector('.hero-wrapper') || document.querySelector('[id*=hero_main]');
      if (!h || h.getAttribute('data-ken')) return;
      h.setAttribute('data-ken', '1');
      var img = h.querySelector('img');
      if (!img) return;
      var p = img.parentElement;
      if (p) p.style.overflow = 'hidden';
      img.classList.add('lux-ken');
    } catch (e) {}
  }

  function visitStrip() {
    try {
      if (location.pathname !== '/') return;
      if (document.querySelector('.lux-visit')) return;
      var foot = document.querySelector('footer') || document.querySelector('[class*=footer]');
      if (!foot) return;
      var host = foot.closest('.shopify-section') || foot;
      var sec = document.createElement('section');
      sec.className = 'lux-visit lux-reveal';
      sec.innerHTML = '<a class="lux-visit__img" href="/pages/contact-us-9five-store-locations"><img src="https://9five.com/cdn/shop/files/9five-store-barrio-web.jpg?width=2000" alt="9FIVE Barrio Logan flagship" loading="lazy"></a><div class="lux-visit__body"><div class="lux-visit__eyebrow">Visit Us</div><h2 class="lux-visit__h">9FIVE Worldwide</h2><div class="lux-visit__locs"><div><strong>Barrio Logan</strong>2163 Logan Ave, San Diego, CA 92113</div><div><strong>Paris, France</strong>18 Route de Bondy, Aulnay-sous-Bois</div></div></div>';
      host.parentNode.insertBefore(sec, host);
      if (window.__luxIO) window.__luxIO.observe(sec);
    } catch (e) {}
  }

  function rxGuard() {
    try {
      if (/clear-prescription-lens/i.test(location.pathname)) {
        var grid = document.querySelector('.product-grid');
        if (grid) {
          [].forEach.call(grid.querySelectorAll('.product-grid__item'), function (card) {
            [].forEach.call(card.querySelectorAll('button[name="add"]'), function (b) {
              b.style.setProperty('display', 'none', 'important');
            });
          });
        }
      }
      var rxPdp = /\/products\//.test(location.pathname) &&
        (/-rx\/?$/.test(location.pathname) || !!document.querySelector('[id*=lensadvisor],[class*=lensadvi]'));
      if (rxPdp) {
        [].forEach.call(document.querySelectorAll('.shopify-payment-button'), function (b) {
          b.style.setProperty('display', 'none', 'important');
        });
      }
    } catch (e) {}
  }

  function rxAutoStart() {
    // #rxstart deep-link: click the LensAdvizor button once it exists. This is the only
    // thing here that legitimately needs to retry, so it gets its own bounded backoff
    // (max ~4s) instead of riding a forever-loop.
    if (location.hash !== '#rxstart' || window.__rxDone) return;
    var tries = 0;
    (function attempt() {
      if (window.__rxDone) return;
      if (/choose your prescription|single vision|progressive/i.test(document.body.innerText || '')) {
        window.__rxDone = true;
        return;
      }
      var lb = document.querySelector('.la-select-lenses-btn,lensadvizor-btn');
      if (lb && lb.offsetParent !== null) {
        ['pointerdown', 'mousedown', 'pointerup', 'mouseup', 'click'].forEach(function (ev) {
          try { lb.dispatchEvent(new MouseEvent(ev, { bubbles: true, cancelable: true, view: window })); } catch (e) {}
        });
        window.__rxDone = true;
        return;
      }
      if (++tries > 15) { window.__rxDone = true; return; }
      setTimeout(attempt, 250);
    })();
  }

  function run() {
    try {
      footMarble();
      atcMarble();
      whySwag();
      sizeFitMove();
      reviewStars();
      scrollReveal();
      featuredCards();
      heroKen();
      visitStrip();
      rxGuard();
    } catch (e) {}
  }

  function boot() {
    run();
    rxAutoStart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  // Section re-render (theme editor, and any section the theme swaps in).
  document.addEventListener('shopify:section:load', function () { setTimeout(run, 60); });
})();
